<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="mb-lg">
            <div class="card" v-if="!isLoading">
              <argon-alert v-if="showAlert" color="danger">
                <strong>Alerta!</strong> Es necesario seleccionar un Documento!
              </argon-alert>
              <argon-alert
                v-if="showSuccess"
                color="success"
                :dismissible="true"
              >
                <strong>Completado!</strong> Campos guardados correctamente!
              </argon-alert>
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0">Documento</h4>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-sm">META</p>
                <hr class="horizontal dark" />
                <div class="row">
                  <div class="col-6">
                    <a v-if="documentLocal !== undefined" :href="documentLocal" target="_blank">
                      DOCUMENTO SELECCIONADO
                    </a>
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Documento</label
                    >
                    <argon-input
                      type="file"
                      id="0"
                      name="Documento"
                      @change-image="onFileChange($event)"
                      accept="application/pdf, image/*"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Nombre</label
                    >
                    <argon-input
                      v-model="document.title"
                      id="1"
                      name="Nombre"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Descripción</label
                    >
                    <argon-textarea
                      v-model="document.description"
                      id="1"
                      name="Descripción"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <argon-button
                      color="primary"
                      size="lg"
                      class="ms-auto"
                      @click-callback="finalValidation"
                      :fullWidth="true"
                      >Guardar</argon-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "document-card",
  props: {
    documentID: { type: String, required: true },
  },
  data() {
    return {
      isLoading: true,
      showAlert: false,
      showSuccess: false,
      valid: Array(4).fill(true),
      documentIDLocal: this.documentID,
      documentLocal: undefined,
      documentLocalSave: undefined,
      document: {
        title: "",
        description: ""
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonAlert, ArgonTextarea },
  created() {
    // console.log("DOCUMENT DOCUMENT DOCUMENT");
    // console.log(this.documentIDLocal);
    if (this.documentIDLocal !== "0") {
      this.plain
        .get(`/documents/${this.documentIDLocal}`)
        .then((response) => {
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.documentLocal = response.data.file_url;
          this.documentLocalSave = response.data.file_url;
          delete response.data.file_url;
          this.document = response.data;
          this.isLoading = false;
          // console.log("RESPONSE DOCUMENT");
          // console.log(this.document);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    } else {
      this.documentIDLocal = undefined;
      this.isLoading = false;
    }
  },
  methods: {
    absoluteValidation(event) {
      this.showAlert = false;
      this.showSuccess = false;
      this.valid[event.inputIndex] = event.valid;
    },
    finalValidation() {
      if (this.valid.includes(false)) {
        this.showAlert = true;
        window.scrollTo(0, 0);
      } else {
        if (this.documentIDLocal !== undefined) this.editDocument();
        else {
          // console.log(this.documentLocal);
          if (this.documentLocal !== undefined) this.createDocument();
          else {
            this.showAlert = true;
            window.scrollTo(0, 0);
          }
        }
      }
    },
    createDocument() {
      // console.log("CREANDO DOCUMENT");
      // console.log(this.document);
      let formData = new FormData();

      Object.entries(this.document).forEach(([key, value]) => {
        formData.append(`document[${key}]`, value);
      });

      this.form
        .post("/documents", formData)
        .then((response) => {
          // console.log("DOCUMENT creado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.documentIDLocal = response.data.id; //SOLUCIONAR PROBLEMA DE ALERTAS AQUI ES CON LA NAVEGACION route y con una variable local
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.documentLocal = response.data.file_url;
          this.documentLocalSave = response.data.file_url;
          delete response.data.file_url;
          this.document = response.data;
          // console.log("CREATE");
          // console.log(this.document);
        })
        .catch((error) => {
          console.log("Error al crear DOCUMENTS", error);
        });
    },
    editDocument() {
      // console.log("PREPARANDO PARA EDITAR");
      // console.log(this.document);
      let formData = new FormData();

      Object.entries(this.document).forEach(([key, value]) =>
        formData.append(`document[${key}]`, value)
      );
      this.form
        .patch(`/documents/${this.documentIDLocal}`, formData)
        .then((response) => {
          // console.log("DOCUMENT editado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.documentLocal = response.data.file_url;
          this.documentLocalSave = response.data.file_url;
          delete response.data.file_url;
          this.document = response.data;
          // console.log("EDIT");
          // console.log(this.document);
        })
        .catch((error) => {
          console.log("Error al editar DOCUMENTS", error);
        });
    },
    onFileChange(file) {
      // console.log("FILE");
      // console.log(file);
      if (file !== undefined) {
        this.documentLocal = URL.createObjectURL(file);
        this.document.file = file;
        this.showAlert = false;
        // console.log("ON FILE CHANGE");
        // console.log(this.document);
      } else {
        if (Object.keys(this.document).includes("image"))
          delete this.document.file;

        this.documentLocal = this.documentLocalSave;
      }
    },
  },
};
</script>